export function render(barcodeData) {
  var elt = {
    sym: "datamatrix",
    desc: "Data Matrix",
    text: "This is Data Matrix!",
    opts: "",
  };

  var text = barcodeData;
  var alttext = "";
  var options = "";
  var rotate = "N";
  var scaleX = 4;
  var scaleY = 4;
  var renderAs = "render-canvas";

  // Convert the options to an object.
  let opts = {};
  let aopts = options.split(" ");
  for (let i = 0; i < aopts.length; i++) {
    if (!aopts[i]) {
      continue;
    }
    var eq = aopts[i].indexOf("=");
    if (eq == -1) {
      // !name => false
      // name => true
      if (aopts[i][0] == "!") {
        opts[aopts[i].substr(1)] = false;
      } else {
        opts[aopts[i]] = true;
      }
    } else {
      opts[aopts[i].substr(0, eq)] = aopts[i].substr(eq + 1);
    }
  }

  // Finish up the options
  opts.text = text;
  opts.bcid = elt.sym;
  opts.scaleX = scaleX;
  opts.scaleY = scaleY;
  opts.rotate = rotate;
  if (alttext) {
    opts.alttext = alttext;
  }

  if (renderAs == "render-canvas") {
    // Draw the bar code to the canvas
    try {
      let ts0 = new Date();
      bwipjs.toCanvas(canvas, opts);
      // showCVS(ts0, new Date());
      var img = canvas.toDataURL();
      var imgElement = document.createElement('img');
      imgElement.src = img;
      let barcodeBox=document.querySelector('.barcode-print-container');
      while (barcodeBox.firstChild) {
        barcodeBox.removeChild(barcodeBox.firstChild);
      }
      barcodeBox.appendChild(imgElement);
    } catch (e) {
      // Watch for BWIPP generated raiseerror's.
      var msg = ("" + e).trim();
      if (msg.indexOf("bwipp.") >= 0) {
        console.log(msg);
      } else if (e.stack) {
        // GC includes the message in the stack.  FF does not.
        console.log((e.stack.indexOf(msg) == -1 ? msg + "\n" : "") + e.stack);
      } else {
        console.log(msg);
      }
      return;
    }
  } else {
  }

  function showCVS(ts0, ts1) {
    canvas.style.display = "";
    //   saveCanvas.basename =
    //     elt.sym + "-" + text.replace(/[^a-zA-Z0-9._]+/g, "-");
    if (window.devicePixelRatio) {
      canvas.style.zoom = 1 / window.devicePixelRatio;
    } else {
      canvas.style.zoom = 1;
    }
  }
}
